/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@mui/material';

const ErroIntegracaoBanner = ({ errorCount, onVerErros }) => {
  if (!errorCount || errorCount <= 0) return null;

  return (
    <Alert
      severity="error"
      variant="filled"
      sx={{
        borderRadius: 2,
        alignItems: 'center',
        '& .MuiAlert-message': { flex: 1 },
      }}
      action={
        <Button color="inherit" onClick={onVerErros} size="small" variant="outlined">
          Ver erros
        </Button>
      }
    >
      <strong>{errorCount}</strong>
      {` integração${errorCount !== 1 ? 'ões' : ''} com erro nos seus envios no período`}
    </Alert>
  );
};

ErroIntegracaoBanner.propTypes = {
  errorCount: PropTypes.number,
  onVerErros: PropTypes.func.isRequired,
};

ErroIntegracaoBanner.defaultProps = {
  errorCount: 0,
};

export default ErroIntegracaoBanner;
